import Vue from 'vue';
import VueRouter from "vue-router";
import VueCarousel from 'vue-carousel';
import _ from 'lodash';
import App from './App.vue';
import Cards from './assets/json/cards.json'

import "uikit/dist/js/uikit.js";
import "uikit/dist/css/uikit.css";

console.log("Vue", Vue.version);
Vue.use(VueRouter);
Vue.use(VueCarousel);
Vue.config.productionTip = false;

// データの整形 複数シート分取り込みフラットにする
window.cards = _.flatten(Cards.map(function (sheet) {
  return sheet.map(function (card) {
    return {
      key: _.kebabCase(card["Name"]),
      en: _.toUpper(card["Name"]),
      ja: card["ja"],
      game: card["Game"],
      type: card["CardType"],
      qty: card["Qty"],
      image_url: require('./assets/media/' + _.kebabCase(card["Name"]) + '.jpg'),
      cost: {
        materials: card["CostMaterials"],
        energy: card["CostEnergy"],
        science: card["CostScience"],
        gold: card["CostGold"],
        exploration: card["CostExploration"],
        krystallium: card["CostKrystallium"],
        financier: card["CostFinancier"],
        general: card["CostGeneral"],
      },
      production: {
        materials: card["ProductionMaterials"],
        energy: card["ProductionEnergy"],
        science: card["ProductionScience"],
        gold: card["ProductionGold"],
        exploration: card["ProductionExploration"],
        materialsBy: card["ProductionMaterialsByDevelopment"],
        energyBy: card["ProductionEnergyByDevelopment"],
        scienceBy: card["ProductionScienceByDevelopment"],
        goldBy: card["ProductionGoldByDevelopment"],
        explorationBy: card["ProductionExplorationByDevelopment"],
      },
      recyclingBonus: {
        materials: card["RecyclingBonusMaterials"],
        energy: card["RecyclingBonusEnergy"],
        science: card["RecyclingBonusScience"],
        gold: card["RecyclingBonusGold"],
        exploration: card["RecyclingBonusExploration"],
        krystallium: card["RecyclingBonusKrystallium"],

      },
      constructionBonus: {
        materials: card["ConstructionBonusMaterials"],
        energy: card["ConstructionBonusEnergy"],
        science: card["ConstructionBonusScience"],
        gold: card["ConstructionBonusGold"],
        exploration: card["ConstructionBonusExploration"],
        krystallium: card["ConstructionBonusKrystallium"],
        financier: card["ConstructionBonusFinancier"],
        general: card["ConstructionBonusGeneral"],
      },
      victoryPoint: {
        direct: card["VictoryPointDirect"],
        structure: card["VictoryPointStructure"],
        vehicle: card["VictoryPointVehicle"],
        research: card["VictoryPointResearch"],
        project: card["VictoryPointProject"],
        discovery: card["VictoryPointDiscovery"],
        financier: card["VictoryPointFinancier"],
        general: card["VictoryPointGeneral"],
      },
    };
  })
}));

import Explorer from "@/components/Explorer";

// ルーティング
var router = new VueRouter({
  routes: [
    { path: '/', redirect: '/cards' },
    { path: '/cards', component: Explorer },
    { path: '*', redirect: '/cards' },
  ]
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
